import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import WhoWeServe from './components/WhoWeServe';
import Services from './components/Services';
import Estimation from './components/Estimation';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <AboutUs />
        <WhoWeServe />
        <Services />
        <Estimation />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
